<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen pt_lgbg flex w-full vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color rounded" :class="{'bg-white': $store.state.dash.logoURL}">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="$store.state.dash.logoURL"  class="pt_nofilter mx-auto" style="max-height: 50px; max-width: 100%;" :src="$store.state.dash.logoURL"/>
              <img v-else  class="pt_nofilter mx-auto w-48" src="@/assets/images/logo/logo.png"/>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg rounded">
              <div class="px-8 py-12 login-tabs-container">
                <div class="vx-card__title mb-4">                  
                  <span class="block lg:hidden">
                  <img v-if="$store.state.dash.logoURL"  class="pt_nofilter mx-auto" style="max-height: 50px; max-width: 100%;" :src="$store.state.dash.logoURL"/>
                    <img v-else  class="pt_nofilter mx-auto w-48 my-5 mb-10" src="@/assets/images/logo/logo.png"/>
                  </span>  
                    <h3 class="mb-4">Login</h3>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <login-firebase></login-firebase>
                <p v-if="!$store.state.dash.brandHex" class="mt-4">Don't have a Feedback Link? <a href="" @click.prevent="registerUser" class="text-primary underline">Try it free</a></p>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>

/*

SOCIAL LOGIN

<vs-divider class="my-8">OR</vs-divider>

<div class="social-login-buttons flex flex-wrap items-center my-6">

  <!-- facebook -->
  <div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithFacebook">
    <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="currentColor" d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"></path></svg>
  </div>

  <!-- TWITTER -->
  <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithTwitter">
    <svg aria-hidden="true" focusable="false" data-icon="x" class="text-white h-4 w-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"></path></svg>
  </div>

  <!-- GOOGLE -->
  <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGoogle">
    <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
  </div>

</div>

*/

import LoginFirebase from './LoginFirebase.vue'


export default {
  components: {
    LoginFirebase
  },
  methods: {
    registerUser () {
      this.$router.push('/dash/signup').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {    

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
